import { defineStore } from 'pinia'

import { useApi } from '@/composables/api'

interface AuthState {
  logout_token: string | null
}

const baseUrl = process.env.VUE_APP_PUBLIC_BASE_URL

export const useAuthStore = defineStore({
  id: 'auth',
  state: (): AuthState => ({
    logout_token: null,
  }),
  actions: {
    async checkAccess() {
      return useApi('GET', `${window.location.origin}${baseUrl}modules-choice`)
        .then((resp) => {
          if (resp.status == 200) {
            return true
          } else {
            if (localStorage.getItem('user')) {
              localStorage.removeItem('user')
            }
            return false
          }
        })
        .catch(() => {
          throw new Error('Error: Unable to check if you are logged in')
        })
    },

    async login(name: string, pass: string) {
      return useApi(
        'POST',
        `${window.location.origin}${baseUrl}user/login?_format=json`,
        JSON.stringify({
          name,
          pass,
        })
      )
        .then(async (resp: Response) => {
          if (resp.status == 200) {
            const reponse = await resp.json()

            this.logout_token = reponse['logout_token']
            localStorage.setItem(
              'user',
              JSON.stringify({ logout_token: this.logout_token })
            )
            return true
          }
        })
        .catch(() => {
          throw new Error('Error: Unable to sign user')
        })
    },

    logout() {
      const userItem = localStorage.getItem('user')
      const userInfo = userItem ? JSON.parse(userItem) : null

      if (userInfo && userInfo.logout_token) {
        return useApi(
          'POST',
          `${window.location.origin}${baseUrl}user/logout?_format=json&token=${userInfo.logout_token}`
        )
          .then(() => {
            localStorage.removeItem('user')
          })
          .catch(() => {
            throw new Error('Error: Unable to logout user')
          })
      }
    },
  },
})
